import { useContext } from "react";

import { IntlContext, UPSContext } from "@app/provider";
import { useGeneratedTokenizedLink } from "@app/hooks";
import { TokenizedLinkAction } from "@app/hooks/useTokenizedLinks";
import {
  GeneratedTokenizedLink,
  UPSNotificationTemplate,
} from "@app/hooks/useGeneratedTokenizedLink";

const useTokenizedLinkSignUp = (): {
  redirectToTokenizedSignUp: () => Promise<void>;
  isLoading: boolean;
} => {
  const { currentLanguage } = useContext(IntlContext);
  const { upsPatientUid } = useContext(UPSContext);
  const { isLoading, getTokenizedLink } = useGeneratedTokenizedLink();

  const redirectToTokenizedSignUp = async (): Promise<void> => {
    if (!upsPatientUid) {
      return;
    }

    const tokenizedLinkData: GeneratedTokenizedLink = {
      action: TokenizedLinkAction.TOKENIZED_LINK_SIGN_UP,
      data: {
        patientUid: upsPatientUid,
        language: currentLanguage,
        notificationType: UPSNotificationTemplate.UPS_COMM,
      },
      shortened: false,
    };

    const payload = await getTokenizedLink(tokenizedLinkData);

    if (payload?.link) {
      window.location.href = payload.link;
    }
  };

  return { redirectToTokenizedSignUp, isLoading };
};

export default useTokenizedLinkSignUp;
